/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Fairusefactors_Limited2Inputs */

const id_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penggunaan Terbatas:`)
};

const ms_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penggunaan Terhad:`)
};

const da_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrænset Brug:`)
};

const de_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrenzte Nutzung:`)
};

const en_us2_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limited Use:`)
};

const es_es2_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso limitado:`)
};

const es_mx2_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso limitado:`)
};

const fil_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limitadong Paggamit:`)
};

const fr_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilisation limitée :`)
};

const it_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso limitato:`)
};

const hu_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korlátozott felhasználás:`)
};

const nl_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beperkt gebruik:`)
};

const no_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begrenset bruk:`)
};

const pl_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ograniczone użycie:`)
};

const pt_br2_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso limitado:`)
};

const pt_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uso limitado:`)
};

const ro_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizare limitată:`)
};

const fi_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rajoitettu käyttö:`)
};

const sv_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begränsad användning:`)
};

const vi_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sử dụng hạn chế:`)
};

const tr_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sınırlı Kullanım:`)
};

const cs_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Omezené použití:`)
};

const bg_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограничена употреба:`)
};

const ru_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ограниченное использование:`)
};

const uk_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обмежене використання:`)
};

const ar_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استخدام محدود:`)
};

const hi_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सीमित उपयोग:`)
};

const th_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การใช้งานอย่างจำกัด:`)
};

const ja_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`限定的な使用：`)
};

const zh_cn2_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有限使用：`)
};

const zh_hant1_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有限使用：`)
};

const ko_about_fairusefactors_limited2 = /** @type {(inputs: About_Fairusefactors_Limited2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제한된 사용:`)
};

/**
* | output |
* | --- |
* | "Limited Use:" |
*
* @param {About_Fairusefactors_Limited2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_fairusefactors_limited2 = /** @type {((inputs?: About_Fairusefactors_Limited2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Fairusefactors_Limited2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_fairusefactors_limited2(inputs)
	if (locale === "ms") return ms_about_fairusefactors_limited2(inputs)
	if (locale === "da") return da_about_fairusefactors_limited2(inputs)
	if (locale === "de") return de_about_fairusefactors_limited2(inputs)
	if (locale === "en-US") return en_us2_about_fairusefactors_limited2(inputs)
	if (locale === "es-ES") return es_es2_about_fairusefactors_limited2(inputs)
	if (locale === "es-MX") return es_mx2_about_fairusefactors_limited2(inputs)
	if (locale === "fil") return fil_about_fairusefactors_limited2(inputs)
	if (locale === "fr") return fr_about_fairusefactors_limited2(inputs)
	if (locale === "it") return it_about_fairusefactors_limited2(inputs)
	if (locale === "hu") return hu_about_fairusefactors_limited2(inputs)
	if (locale === "nl") return nl_about_fairusefactors_limited2(inputs)
	if (locale === "no") return no_about_fairusefactors_limited2(inputs)
	if (locale === "pl") return pl_about_fairusefactors_limited2(inputs)
	if (locale === "pt-BR") return pt_br2_about_fairusefactors_limited2(inputs)
	if (locale === "pt") return pt_about_fairusefactors_limited2(inputs)
	if (locale === "ro") return ro_about_fairusefactors_limited2(inputs)
	if (locale === "fi") return fi_about_fairusefactors_limited2(inputs)
	if (locale === "sv") return sv_about_fairusefactors_limited2(inputs)
	if (locale === "vi") return vi_about_fairusefactors_limited2(inputs)
	if (locale === "tr") return tr_about_fairusefactors_limited2(inputs)
	if (locale === "cs") return cs_about_fairusefactors_limited2(inputs)
	if (locale === "bg") return bg_about_fairusefactors_limited2(inputs)
	if (locale === "ru") return ru_about_fairusefactors_limited2(inputs)
	if (locale === "uk") return uk_about_fairusefactors_limited2(inputs)
	if (locale === "ar") return ar_about_fairusefactors_limited2(inputs)
	if (locale === "hi") return hi_about_fairusefactors_limited2(inputs)
	if (locale === "th") return th_about_fairusefactors_limited2(inputs)
	if (locale === "ja") return ja_about_fairusefactors_limited2(inputs)
	if (locale === "zh-CN") return zh_cn2_about_fairusefactors_limited2(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_fairusefactors_limited2(inputs)
	return ko_about_fairusefactors_limited2(inputs)
});
export { about_fairusefactors_limited2 as "about.fairUseFactors.limited" }